import { db, functions, httpsCall, auth, signIn, authChanged } from './Firebase';
import {
  collection,
  getDocs,
  getDoc,
  doc,
  query,
  where,
  setDoc,
  onSnapshot,
} from 'firebase/firestore';
import MetaMask from './MetaMask';

//メタマスクアドレスを取得
const getMetaMaskAddress = async (isElectron = false) => {
  //1.メタマスクのアドレスを取得
  const address = await MetaMask.getAccount();
  if (address == 'noinstall') {
    return 'noinstall';
  }
  if (address == null) return null;

  //2.DBに保存してコード取得
  try {
    var data = {
      address: address,
    };
    const result = await httpsCall(functions, 'getCodeFromAddress')(data);

    return result.data.code;
    //return result.data;
  } catch (error) {
    return null;
  }
};

//ウォレットアドレスからNFT取得
const getAllNFTList = async (address) => {
  try {
    var data = {
      address: address,
    };
    const result = await httpsCall(functions, 'getNFTListFromAddress')(data);

    return result.data;
  } catch (error) {
    return null;
  }
};

//トークンゲート確認
const getTokenGatedNFT = async (address, roomID, tokenGatedType) => {
  try {
    var data = {
      address: address,
      roomID: roomID,
      tokenGatedType: tokenGatedType,
    };
    const result = await httpsCall(functions, 'getTokenGatedNFT')(data);

    return result.data;
  } catch (error) {
    return false;
  }
};

//メタマスクアドレスを取得
const getNFTListFromAddress = async () => {
  const address = await MetaMask.getAccount();

  //まだインストールされていない
  if (address == 'noinstall') {
    //メタマスクページへ飛ばす
    window.location = 'https://metamask.io/';
    return null;
  }
  //エラーまたは拒否された
  else if (address == null) {
    return null;
  }

  //2.DBに保存してコード取得
  try {
    var data = {
      address: address,
    };
    const result = await httpsCall(functions, 'getNFTListFromAddress')(data);

    return result.data;
  } catch (error) {
    return null;
  }
};

//メタマスクの接続解除
const disconnectMetaMask = async (isElectron = false) => {
  //2.DBに保存してコード取得
  try {
    var data = {};
    const result = await httpsCall(functions, 'disconnectMetaMask')(data);
    return result.data;
  } catch (error) {
    return null;
  }
};

//参考:
//Nounceを取得
const login = async (isElectron = false) => {
  //1.メタマスクのアドレスを取得
  const address = await MetaMask.getAccount();
  if (address == 'noinstall') {
    return 'noinstall';
  }
  if (address == null) return;

  //2.Nonceを取得
  const nonce = await getNonce(address);
  if (nonce == null) return;

  //3.メタマスクにsign
  const sign = await MetaMask.getSign(nonce, address);
  if (sign == null) return;

  //エレクトロンの場合はワンタイムコード
  if (isElectron) {
    //4.signのバリデートしてワンタイムコードを取得
    const code = await validateSign(address, sign, isElectron);
    if (code == null) return;

    //コードを返す
    return code;
  }
  //通常の場合はそのままログイン
  else {
    //4.signのバリデートしてユーザー情報取得
    const userData = await validateSign(address, sign, isElectron);
    if (userData == null) return;

    //ユーザーデータを返す
    return userData;
  }
};

//nonceを取得
const getNonce = async (address) => {
  try {
    var data = {
      address: address,
    };
    const result = await httpsCall(functions, 'getNonce')(data);
    return result.data;
  } catch (error) {
    return null;
  }
};

//サインのバリデート
const validateSign = async (address, sign, isElectron) => {
  try {
    var data = {
      address: address,
      sign: sign,
      isElectron: isElectron,
    };
    const result = await httpsCall(functions, 'validateSign')(data);
    return result.data;
  } catch (error) {
    return null;
  }
};

//Firebaseにログイン
const signInFirebase = async (userData) => {
  const authInfo = auth();
  return signIn(authInfo, userData.token)
    .then((userCredential) => {
      // Signed in
      const user = userCredential.user;
      return user;
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.log('ログインエラーです');
      console.log(errorMessage);
      return null;
    });
};

//認証コードからトークンを取得する
const getTokenFromCode = async (code) => {
  try {
    var data = {
      code: code,
    };
    const result = await httpsCall(functions, 'getTokenFromCode')(data);
    return result.data;
  } catch (error) {
    return null;
  }
};

//認証コードからアドレスを取得する
const getAddressFromCode = async (code) => {
  try {
    var data = {
      code: code,
    };
    const result = await httpsCall(functions, 'getAddressFromCode')(data);
    return result.data.address;
  } catch (error) {
    return null;
  }
};

//ユーザー情報取得
const getUserData = async (type) => {
  try {
    var data = {
      type: type,
    };

    const result = await httpsCall(functions, 'getUserData')(data);
    return result.data;
  } catch (error) {
    return null;
  }
};

//特定ユーザー情報取得
const getSpecificUserData = async (type, userID, isMe) => {
  try {
    var data = {
      type: type,
      userID: userID,
      isMe: isMe,
    };

    const result = await httpsCall(functions, 'getSpecificUserData')(data);
    return result.data;
  } catch (error) {
    return null;
  }
};

//ユーザーデータのデーターベースへの保存
const saveUserData = async (type, data1, data2) => {
  try {
    var data = {
      type: type,
    };

    if (type == 'displayName') {
      data.displayName = data1;
    }

    if (type == 'aboutMe') {
      data.aboutMe = data1;
    }

    if (type == 'twitter') {
      data.twitterURL = data1;
    }

    if (type == 'imageURL') {
      data.imageURL = data1;
      data.nftID = data2;
    }

    if (type == 'backImage') {
      data.backImageURL = data1;
    }

    const result = await httpsCall(functions, 'saveUserData')(data);
    return result.data;
  } catch (error) {
    return null;
  }
};

//NFTのデーターベースへの保存
const saveNFT = async (nft) => {
  try {
    var data = {
      nft: nft,
    };

    const result = await httpsCall(functions, 'saveNFT')(data);
    return result.data;
  } catch (error) {
    return null;
  }
};

//所有しているNFTのリストを取得
const getOwnNFTList = async () => {
  try {
    var data = {};

    const result = await httpsCall(functions, 'getOwnNFTList')(data);
    return result.data;
  } catch (error) {
    return null;
  }
};

//NFTのリストを取得
const getNFTList = async (address) => {
  try {
    var data = {
      address: address,
    };

    const result = await httpsCall(functions, 'getNFTList')(data);
    return result.data;
  } catch (error) {
    return null;
  }
};

//パートナー用のNFTデータを挿入
const addNFTDetail = async () => {
  var data = {
    nftID: 'ethereum.0x0ff1458cab4a4673b913040e011c14b81d656ceb.6443',
    contractAddress: '0x0fF1458cab4A4673b913040E011c14B81d656ceb',
    name: 'Queen & King #4566',
    description: 'Queen & King detail',
    whoCanUse: 'allholders',
    nftDetailURL: 'https://hacktao.com',
    nftVideoURL: '',
    type: 'user',
    chain: 'ethereum',
    contractType: 'ERC721',
    key: 4,
    hpURL: 'https://hacktao.com',
    collectionName: 'Queens+Kings',
    collectionImageURL: '',
    collectionDescription:
      'Queens+Kings overthrow hierarchies in contemporary art and re-mint your CryptoRealm:\r\nCreated by Hackatao and NFT Studios, supported by Sotheby’s\r\n\r\n6,900 Queens+Kings:',
    collectionURL: 'https://hacktao.com',
    collectionTwitterURL: 'https://hacktao.com',
    collectionDiscordURL: 'https://hacktao.com',
    collectionOpenseaURL: 'https://hacktao.com',
    imageURL:
      'https://cdn.simplehash.com/assets/f033da6998ddc1d47a8116f9397cc07ab0ff1b060a8a34cbf9335e0eda6f5b93.gif',
    mediumImageURL:
      'https://lh3.googleusercontent.com/g4HPeZG1MKNgz5JXft0nTw5JCIv7NALGsGAIGK6VwebbUU4hsgMFyVnzbHu5uwOt19ZW6bIx09qjZjRX7pPT4jiaSyq_MuySbgue',
    smallImageURL:
      'https://lh3.googleusercontent.com/g4HPeZG1MKNgz5JXft0nTw5JCIv7NALGsGAIGK6VwebbUU4hsgMFyVnzbHu5uwOt19ZW6bIx09qjZjRX7pPT4jiaSyq_MuySbgue=s250',
  };
  const roomRef = doc(db, 'nft', data.nftID);
  await setDoc(roomRef, data, { merge: true });
};

//パートナー用のNFTデータを挿入
const addNFT = async (nft) => {
  var data = nft;
  const roomRef = doc(db, 'nft', data.nftID);
  await setDoc(roomRef, data, { merge: true });
};

//ルームへのデーターベースへの保存
const saveSessionToRoom = async (
  roomID,
  sessionID,
  localUserSessionID,
  imageURL,
  backImageURL,
  isFaceTracking,
  isRecording,
  isMute,
  nftWhoCanUse,
  userType,
  BGM,
  BGMVolume,
) => {
  //ローカルストレージから取得する
  var displayName = null;
  var nftID = null;
  var twitterURL = null;

  if (localStorage.getItem('displayName')) {
    displayName = localStorage.getItem('displayName');
  }
  if (localStorage.getItem('nftID')) {
    nftID = localStorage.getItem('nftID');
  }
  if (localStorage.getItem('twitterURL')) {
    twitterURL = localStorage.getItem('twitterURL');
  }

  try {
    var data = {
      roomID: roomID,
      sessionID: sessionID,
      tempUserID: localUserSessionID,
      displayName: displayName,
      nftID: nftID,
      twitterURL: twitterURL,
      userType: userType,
    };

    //画像の指定がある場合
    if (imageURL != null) {
      data.imageURL = imageURL;
    }

    //録画中がある場合
    if (isRecording != null) {
      data.isRecording = isRecording;
    }

    //ミュート状態がある場合
    if (isMute != null) {
      data.isMute = isMute;
    }

    //背景の指定がある場合
    if (backImageURL != null) {
      data.backImageURL = backImageURL;
    }

    //顔認識
    if (isFaceTracking != null) {
      data.isFaceTracking = isFaceTracking;
    }

    //NFTが誰が使えるか
    if (nftWhoCanUse != null) {
      data.nftWhoCanUse = nftWhoCanUse;
    }

    //BGM
    if (BGM != null) {
      data.BGM = BGM;
    }

    //BGMボリューム
    if (BGMVolume != null) {
      data.BGMVolume = BGMVolume;
    }

    const result = await httpsCall(functions, 'saveSessionToRoom')(data);
    return result.data;
  } catch (error) {
    return null;
  }
};

//ルームセッションの更新
const updateSessionToRoom = async (sessionID, type, data1) => {
  try {
    const data = {
      sessionID: sessionID,
      type: type,
      data1: data1,
    };

    const result = await httpsCall(functions, 'updateSessionToRoom')(data);
    return result.data;
  } catch (error) {
    return null;
  }
};

//現状のセッション情報を取得
const selectSessionData = async (
  sessionID,
  setSessionUsers,
  setMyNftBackState,
  setBGMState,
  setBGMVolumeState,
) => {
  //スナップショットをリッスン
  const unsub = onSnapshot(doc(db, 'sessions', sessionID), (doc) => {
    if (doc.exists()) {
      const sessionData = doc.data();

      //画像変更
      setSessionUsers(sessionData.userDetails);

      //背景変更
      if (sessionData.backImageURL != null) {
        // console.log('セッションから背景変更');
        setMyNftBackState(sessionData.backImageURL);
      }

      //BGMの変更
      if (sessionData.BGM != null) {
        if (sessionData.BGM == 'stop') {
          setBGMState(null);
        } else {
          setBGMState(sessionData.BGM);
        }
      } else {
        setBGMState(null);
      }

      //BGMのボリューム変更
      if (sessionData.BGMVolume != null) {
        setBGMVolumeState(sessionData.BGMVolume);
      } else {
        // setBGMVolumeState('30');
      }
    } else {
      //データを空にする
      setSessionUsers({});
    }
  });

  return unsub;
};

//パートナーNFT一覧を取得
const getPartnerNFT = async (type, roomID, language) => {
  try {
    const data = {
      type: type,
      roomID: roomID,
      language: language,
    };

    const result = await httpsCall(functions, 'getList')(data);
    return result.data;
  } catch (error) {
    return null;
  }
};

//NFT詳細を取得
const getNFTDetail = async (nftID) => {
  //トークンからユーザー情報取得
  const q = query(collection(db, 'nft'), where('nftID', '==', nftID));
  const querySnapshot = await getDocs(q);
  var detail = {};

  //データが存在する場合
  if (querySnapshot.empty == false) {
    var count = 0;
    querySnapshot.forEach(async (document) => {
      if (count == 0) {
        let data = document.data();
        detail = data;
      }
      count += 1;
    });

    return detail;
  } else {
    return null;
  }
};

//ルームの確認
async function checkRoom(roomID, live = false, tokenID = null) {
  try {
    const data = {
      roomID: roomID,
      live: live,
      tokenID: tokenID,
    };

    const result = await httpsCall(functions, 'checkRoom')(data);
    return result.data;
  } catch (error) {
    return null;
  }
}

//ルームの作成
async function createRoom() {
  try {
    const data = {
      roomID: '',
    };

    const result = await httpsCall(functions, 'createRoom')(data);
    return result.data;
  } catch (error) {
    return null;
  }
}

//エラーの送信
async function sendError(errorString) {
  try {
    const data = {
      error: errorString,
    };

    const result = await httpsCall(functions, 'sendError')(data);
    return result.data;
  } catch (error) {
    return null;
  }
}

//メールログイン
async function mailLogin(email, language) {
  try {
    const data = {
      email: email,
      language: language,
    };

    const result = await httpsCall(functions, 'sendEmail')(data);
    return result.data;
  } catch (error) {
    return null;
  }
}

//許可リストのチェック
async function checkAllowList(email, type = 'email', code = null) {
  try {
    const data = {
      type: type,
      email: email,
      code: code,
    };

    const result = await httpsCall(functions, 'checkAllowList')(data);
    return result.data;
  } catch (error) {
    return false;
  }
}

//メールログインのチェック
async function checkEmailCode(email, code, language) {
  try {
    const data = {
      email: email,
      code: code,
      language: language,
    };

    const result = await httpsCall(functions, 'checkEmailCode')(data);
    return result.data;
  } catch (error) {
    return null;
  }
}

//メールログインのチェック
async function checkEmailToken(token, language) {
  try {
    const data = {
      token: token,
      language: language,
    };

    const result = await httpsCall(functions, 'checkEmailToken')(data);
    return result.data;
  } catch (error) {
    return null;
  }
}

//メールログインのチェック
async function signUpWithEmail(email, language) {
  try {
    const data = {
      email: email,
      language: language,
    };

    const result = await httpsCall(functions, 'signUpWithEmail')(data);
    return result.data;
  } catch (error) {
    return null;
  }
}

//メールログインのチェック
async function signUpToken(email, language) {
  try {
    const data = {
      email: email,
      language: language,
    };

    const result = await httpsCall(functions, 'signUpToken')(data);
    return result.data;
  } catch (error) {
    return null;
  }
}

//メールログインのチェック
async function signUpWithOneTimeEmail(email, language) {
  try {
    const data = {
      email: email,
      language: language,
    };

    const result = await httpsCall(functions, 'signUpWithOneTimeEmail')(data);
    return result.data;
  } catch (error) {
    return null;
  }
}

//フィードバック
async function sendFeedback(body) {
  try {
    const data = {
      body: body,
    };

    const result = await httpsCall(functions, 'sendFeedback')(data);
    return true;
  } catch (error) {
    return false;
  }
}

//フィードバック
async function addAccess(type, action, detail, tempUserID, roomID, localSessionID, isElectron) {
  try {
    const data = {
      type: type,
      action: action,
      detail: detail,
      roomID: roomID,
      localSessionID: localSessionID,
      tempUserID: tempUserID,
      displayName: localStorage.getItem('displayName') ?? null,
      nftID: localStorage.getItem('nftID') ?? null,
      backImageURL: localStorage.getItem('backImageURL') ?? null,
      isElectron: isElectron,
    };
    httpsCall(functions, 'addAccess')(data);
  } catch (error) {
    console.log(error);
  }
}

//Live追加
async function addLive(title, startDate, timezone) {
  try {
    const data = {
      title: title,
      startDate: startDate,
      timezone: timezone,
    };
    httpsCall(functions, 'addLive')(data);
  } catch (error) {
    console.log(error);
  }
}

//Live編集
async function createLive(imageURL) {
  try {
    const data = {
      imageURL: imageURL,
    };
    const result = await httpsCall(functions, 'createLive')(data);
    return result.data;
  } catch (error) {
    console.log(error);
    return false;
  }
}

//Live編集
async function editLive(
  roomName,
  title,
  startDate,
  timeZone,
  imageURL,
  gatedData,
  type,
  isMeeting,
) {
  try {
    const data = {
      roomName: roomName,
      title: title,
      startDate: startDate,
      timeZone: timeZone,
      imageURL: imageURL,
      gatedData: gatedData,
      type: type,
      isMeeting,
    };
    const result = await httpsCall(functions, 'editLive')(data);
    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
}

//NFT詳細を取得
const getLiveDetail = async (nftID) => {
  //トークンからユーザー情報取得
  const q = query(collection(db, 'live'), where('title', '==', 'testtest'));
  const querySnapshot = await getDocs(q);
  var detail = {};

  //データが存在する場合
  if (querySnapshot.empty == false) {
    var count = 0;
    querySnapshot.forEach(async (document) => {
      if (count == 0) {
        let data = document.data();
        detail = data;
      }
      count += 1;
    });

    return detail;
  } else {
    return null;
  }
};

//NFT詳細を取得
const checkLiveStatus = async () => {
  try {
    const data = {
      body: '',
    };

    const result = await httpsCall(functions, 'checkLiveStatus')(data);

    return result.data;
  } catch (error) {
    return null;
  }
};

//チャット送信
const sendChat = async (displayName, body, meetingSessionID) => {
  try {
    const data = {
      displayName: displayName,
      body: body,
      meetingSessionID: meetingSessionID,
    };

    const result = await httpsCall(functions, 'sendChat')(data);

    return result.data;
  } catch (error) {
    return null;
  }
};

//チャット情報取得
const getChat = async (meetingSessionID) => {
  try {
    const data = {
      meetingSessionID: meetingSessionID,
    };

    const result = await httpsCall(functions, 'getChat')(data);

    return result.data;
  } catch (error) {
    return null;
  }
};

//録画データ
const saveRecordCloud = async (roomID, fileName, videoURL, folderName, meetingSessionID) => {
  try {
    const data = {
      roomID: roomID,
      fileName: fileName,
      videoURL: videoURL,
      folderName: folderName,
      meetingSessionID: meetingSessionID,
    };

    const result = await httpsCall(functions, 'saveRecordCloud')(data);

    return result.data;
  } catch (error) {
    return null;
  }
};

const getRecordedURL = async (docID) => {
  //トークンからユーザー情報取得
  const docRef = doc(db, 'recorded', docID);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    return docSnap.data();
  } else {
    return null;
  }
};

const getRoomInfo = async (roomID) => {
  const docRef = doc(db, 'room', roomID);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    return docSnap.data();
  } else {
    return null;
  }
};

//クラウド録画一覧
const checkRecordedVideo = async () => {
  try {
    const data = {
      // displayName: displayName,
      body: 'hello',
      // meetingSessionID: meetingSessionID,
    };

    const result = await httpsCall(functions, 'checkRecordedVideo')(data);

    return result.data;
  } catch (error) {
    return null;
  }
};

//
const awsUploadStart = async (fileName, roomID, meetingSessionID, uniqueName, hlsURL, mp4URL) => {
  try {
    const data = {
      fileName: fileName, // 'row/test.webm',
      roomID: roomID,
      meetingSessionID: meetingSessionID,
      uniqueName: uniqueName,
      hlsURL: hlsURL,
      mp4URL: mp4URL,
      type: 'start',
    };

    const result = await httpsCall(functions, 'awsMultiUpload')(data);

    return result.data;
  } catch (error) {
    return null;
  }
};

//
const awsUploadGetURL = async (fileName, uploadID, partNum, contentType) => {
  try {
    const data = {
      fileName: fileName,
      uploadID: uploadID,
      partNum: partNum,
      contentType: contentType,
      type: 'getURL',
    };

    const result = await httpsCall(functions, 'awsMultiUpload')(data);

    return result.data;
  } catch (error) {
    return null;
  }
};

const getRecordedVideo = async (roomID) => {
  try {
    const data = {
      roomID: roomID,
    };

    const result = await httpsCall(functions, 'getRecordedVideo')(data);

    return result.data;
  } catch (error) {
    return null;
  }
};

const abortRecordedVideo = async (fileName, uploadID) => {
  try {
    const data = {
      fileName: fileName,
      uploadID: uploadID,
      type: 'abort',
    };

    const result = await httpsCall(functions, 'awsMultiUpload')(data);

    return result.data;
  } catch (error) {
    return null;
  }
};

const partRecordedVideo = async (recordedID, parts) => {
  try {
    const data = {
      recordedID: recordedID,
      parts: parts,
      type: 'part',
    };

    const result = await httpsCall(functions, 'awsMultiUpload')(data);

    return result.data;
  } catch (error) {
    return null;
  }
};

const completeRecordedVideo = async (recordedID, fileName, uploadID, parts) => {
  try {
    const data = {
      recordedID: recordedID,
      fileName: fileName,
      uploadID: uploadID,
      parts: parts,
      type: 'complete',
    };

    const result = await httpsCall(functions, 'awsMultiUpload')(data);

    return result.data;
  } catch (error) {
    return null;
  }
};

const searchOpenseaSlug = async (slug) => {
  try {
    const data = {
      slug: slug,
    };

    const result = await httpsCall(functions, 'getOpenseaSlug')(data);

    return result.data;
  } catch (error) {
    return null;
  }
};

const searchContractAddress = async (contractAddress) => {
  try {
    const data = {
      contractAddress: contractAddress,
    };

    const result = await httpsCall(functions, 'getContractAddress')(data);

    return result.data;
  } catch (error) {
    return null;
  }
};

const getFaceData = async (url) => {
  try {
    const data = {
      imageURL: url,
    };

    const result = await httpsCall(functions, 'getFaceData')(data);

    return result.data;
  } catch (error) {
    return null;
  }
};

const saveCustomAvatar = async (avatar) => {
  try {
    const data = {
      avatarData: avatar,
    };

    const result = await httpsCall(functions, 'saveCustomAvatar')(data);

    return result.data;
  } catch (error) {
    return null;
  }
};

const getCustomJson = async (patternID) => {
  try {
    const data = {
      patternID: patternID,
    };

    const result = await httpsCall(functions, 'getCustomJson')(data);

    return result.data;
  } catch (error) {
    return null;
  }
};

const getMyCustomAvatar = async () => {
  try {
    const data = {};
    const result = await httpsCall(functions, 'getMyCustomAvatar')(data);
    return result.data;
  } catch (error) {
    return null;
  }
};

const getMyCustomBackground = async (type) => {
  try {
    const data = {
      type: type ?? 'background',
    };
    const result = await httpsCall(functions, 'getMyCustomBackground')(data);
    return result.data;
  } catch (error) {
    return null;
  }
};

const getCustomBaseInfo = async (baseName, language) => {
  try {
    const data = {
      baseName: baseName,
      language: language,
    };
    const result = await httpsCall(functions, 'getCustomBaseInfo')(data);
    return result.data;
  } catch (error) {
    return null;
  }
};

const sendSpeech = async (text, userID) => {
  try {
    const data = {
      text: text,
      userID: userID,
    };
    const result = await httpsCall(functions, 'sendTextToSpeech')(data);
    return result.data;
  } catch (error) {
    return null;
  }
};

const getUUID = async () => {
  try {
    const data = {};
    const result = await httpsCall(functions, 'getUUID')(data);
    return result.data;
  } catch (error) {
    return null;
  }
};

const saveCustomBackground = async (fileName, type) => {
  try {
    const data = { fileName: fileName, type: type ?? 'background' };
    const result = await httpsCall(functions, 'saveCustomBackground')(data);
    return result.data;
  } catch (error) {
    return null;
  }
};

const saveOriginal = async (fileName) => {
  try {
    const data = { fileName: fileName };
    const result = await httpsCall(functions, 'saveOriginal')(data);
    return result.data;
  } catch (error) {
    return null;
  }
};

const getMeetingList = async () => {
  try {
    const data = {};
    const result = await httpsCall(functions, 'getMeetingList')(data);
    return result.data;
  } catch (error) {
    return null;
  }
};

const createNewMeeting = async (type) => {
  try {
    const data = {
      type: type,
    };
    const result = await httpsCall(functions, 'createNewMeeting')(data);
    return result.data;
  } catch (error) {
    return null;
  }
};

const editMeeting = async (meetingID, type) => {
  try {
    const data = {
      type: type,
      meetingID: meetingID,
    };
    const result = await httpsCall(functions, 'editMeeting')(data);
    return result.data;
  } catch (error) {
    return null;
  }
};

const editRecorded = async (meetingID, type) => {
  try {
    const data = {
      type: type,
      meetingID: meetingID,
    };
    const result = await httpsCall(functions, 'editRecorded')(data);
    return result.data;
  } catch (error) {
    return null;
  }
};

const deleteMeeting = async (meetingID) => {
  try {
    const data = {
      meetingID: meetingID,
    };
    const result = await httpsCall(functions, 'deleteMeeting')(data);
    return result.data;
  } catch (error) {
    return null;
  }
};

const prepareRecording = async (meetingID) => {
  try {
    const data = {
      meetingID: meetingID,
    };
    const result = await httpsCall(functions, 'prepareRecording')(data);
    return result.data;
  } catch (error) {
    return null;
  }
};

const downloadAppRequest = async (meetingID) => {
  try {
    const data = {
      meetingID: meetingID,
    };
    const result = await httpsCall(functions, 'downloadAppRequest')(data);
    return result.data;
  } catch (error) {
    return null;
  }
};

//エクスポート
export default {
  getMetaMaskAddress,
  disconnectMetaMask,
  getNFTListFromAddress,
  login,
  getNonce,
  signInFirebase,
  saveUserData,
  saveSessionToRoom,
  updateSessionToRoom,
  selectSessionData,
  getTokenFromCode,
  getAddressFromCode,
  getAllNFTList,
  getUserData,
  getSpecificUserData,
  saveNFT,
  getNFTList,
  getOwnNFTList,
  addNFT,
  getPartnerNFT,
  getNFTDetail,
  sendError,
  checkRoom,
  createRoom,
  mailLogin,
  checkEmailCode,
  checkEmailToken,
  checkAllowList,
  signUpWithOneTimeEmail,
  sendFeedback,
  addAccess,
  addLive,
  editLive,
  getLiveDetail,
  checkLiveStatus,
  saveRecordCloud,
  getRecordedURL,
  getChat,
  sendChat,
  checkRecordedVideo,
  getTokenGatedNFT,
  getRoomInfo,
  awsUploadStart,
  awsUploadGetURL,
  getRecordedVideo,
  abortRecordedVideo,
  partRecordedVideo,
  completeRecordedVideo,
  createLive,
  searchOpenseaSlug,
  searchContractAddress,
  getCustomJson,
  getFaceData,
  saveCustomAvatar,
  getMyCustomAvatar,
  getCustomBaseInfo,
  sendSpeech,
  getMyCustomBackground,
  getUUID,
  saveCustomBackground,
  getMeetingList,
  createNewMeeting,
  deleteMeeting,
  editMeeting,
  signUpWithEmail,
  signUpToken,
  editRecorded,
  prepareRecording,
  saveOriginal,
  downloadAppRequest,
};
